export var FieldOverrideOnError;
(function (FieldOverrideOnError) {
    FieldOverrideOnError["FIELD_OVERRIDE_ON_ERROR_FAIL"] = "fail";
    FieldOverrideOnError["FIELD_OVERRIDE_ON_ERROR_NULL"] = "null";
})(FieldOverrideOnError || (FieldOverrideOnError = {}));
